const year = new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000);
export default function () {
    return useCookie('cookies_asked', {path: '/', expires: year});
}
